import { ReleaseNotes } from './release-notes.model';
import { ReleaseNoteInput, ReleaseNoteOutput } from '../../../../openapi/build';

export const ReleaseNotesMapper = {
  toApiInput(model: ReleaseNotes): ReleaseNoteInput {
    return <ReleaseNoteInput>{
      version: model.version,
      date: model.date,
      note: model.details
    };
  },

  fromApiOutput(dto: ReleaseNoteOutput): ReleaseNotes {
    return {
      uuid: dto.uuid,
      version: dto.version,
      details: dto.note,
      date: dto.date
    };
  }
};
